import {BackgroundModule} from '@gongxigames/framework/slot';

export class GameBackgroundModule extends BackgroundModule {
}
